<template>
    <el-form  ref="form" :model="form" :rules="rules" label-width="180px">
        <el-form-item label="客户id" v-if="this.$route.path == '/customer-std/update'">
            {{form.id}}
        </el-form-item>
        <el-form-item label="客户名称" prop="name" >
            <el-input v-model.trim="form.name" @input="querySearchAsync($event)"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="comp_code">
            <el-input v-model.trim="form.comp_code"></el-input>
        </el-form-item>
        <el-form-item label="客户简称" prop="short_name">
            <el-input type="textarea" autosize placeholder="可填写多个，按Enter换行分隔" v-model="form.short_name"></el-input>
        </el-form-item>
        <el-form-item label="归属集团" prop="corp_ids">
            <CorpSelect v-model="form.corp_ids" :corp_ids="form.corp_ids" @change="corpChange"></CorpSelect>
        </el-form-item>
        <el-form-item label="学段选择" prop="stages">
            <el-checkbox-group v-model="form.stages">
                <el-checkbox label="1" >小学</el-checkbox>
                <el-checkbox label="2" >初中</el-checkbox>
                <el-checkbox label="3" >高中</el-checkbox>
                <el-checkbox label="4" >中职</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <DistrictLinkage
                :provinceId="parseInt(form.province_id)"
                :cityId="parseInt(form.city_id)"
                :districtId="parseInt(form.district_id)"
                @change="handleChange">
        </DistrictLinkage>
        <el-form-item label="客户类型" prop="type">
            <el-select v-if="types" v-model="form.type" placeholder="请选择" size="small">
                <el-option v-for="(item, key) in types" :key="item" :label="item" :value="parseInt(key)">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="名校标签" prop="tag_ids" v-if="form.type == 1">
            <TagSelect v-model="form.tag_ids" :tag_ids="form.tag_ids" @change="tagChange" :key="1"></TagSelect>
        </el-form-item>
        <el-form-item label="办学性质" prop="school_type" v-if="form.type == 1">
            <el-select v-model="form.school_type" placeholder="请选择">
                <el-option label="民办" :value="1"></el-option>
                <el-option label="公办" :value="2"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="授权站点" prop="auth_site_ids">
            <AuthSite v-model="form.auth_site_ids" :ids="form.auth_site_ids" @change="authSiteChange"></AuthSite>
        </el-form-item>
        <el-form-item label="备注信息">
            <el-input v-model="form.memo"></el-input>
        </el-form-item>
        <el-form-item label="创建人" v-if="$route.path == '/customer-std/update'">
            {{form.operator_name}}
        </el-form-item>
        <el-form-item label="创建时间" v-if="$route.path == '/customer-std/update'">
            {{form.created_at}}
        </el-form-item>
        <el-form-item>
            <el-button type="primary" :loading="loading" @click="submitForm()">立即保存</el-button>
            <!-- <el-button @click="$router.back();">取消</el-button> -->
        </el-form-item>

    </el-form>
</template>

<script>
import CustomerService from "~/services/customer";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import CorpSelect from "~/widgets/CorpSelect.vue";
import TagSelect from "~/widgets/TagSelect.vue";
import AuthSite from "~/widgets/AuthSite.vue";
import Config from "~/config/params";
import CommonService from "~/services/common";


export default {
    name: "subForm",
    components: {
        CustomerService,
        DistrictLinkage,
        Config,
        CorpSelect,
        TagSelect,
        AuthSite
    },

    props: {
        model: {
            type: Object,
            required: false,
            value: function () {
                return {};
            }
        },
        customerId: "",
    },

    data() {

        var validateName = (rule,value,callback) => {
            if(value.indexOf('测试') !=-1) {
                callback(new Error('客户名称禁止含有“测试”词语'));
            } else {
                callback();
            }
        };

        return {
            form: {},
            types: {},
            loading:false,
            config:[],
            // {value:1,label:'系统客户'}, //新增客户时禁选 (系统客户,开发) 类型
                // {value:2,label:'开发'},
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入客户姓名",
                        trigger: "change"
                    },
                    {
                        validator: validateName,
                        trigger: 'change'
                    }
                ],
                comp_code: [{required: true, message: "请输入统一社会信用代码", trigger: "blur"}],
                stages: [{required: true, message: "请选择学段", trigger: "change"}],
                type: [{required: true, message: "请选择客户类型", trigger: "change"}],
                province_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
                city_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
                district_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
            },
            kehu_names: [],
            types: CustomerService.getTypes(),
        };
    },

    created() {
        if(this.model){
            this.form = _.clone(this.model);
        }else{
            this.resetForm();
        }
    },

    methods: {
        // 提交表单
        submitForm() {
            this.loading = true;
            this.$refs["form"].validate(valid => {
                if (valid) {
                    // this.form.username = undefined;
                    this.$emit("submit", this.form);
                } else {
                    this.loading = false;
                    return false;
                }
            });
        },

        // 重置表单
        resetForm() {
            this.form = {
                id: '',
                name: '',
                comp_code: '',
                short_name: '',
                corp_ids: [],
                stages: [],
                province_id: '',
                city_id: '',
                district_id: '',
                type: '',
                tag_ids: [],
                auth_site_ids: [],
                school_type: '',
                memo: '',
                level: 3
            };
        },

        //地区联动 Cascader 级联选择器,切换事件,表单model赋值
        handleChange(value) {
            this.form.province_id = Number(value[0]);
            this.form.city_id = Number(value[1]);
            this.form.district_id = Number(value[2]);
        },

        corpChange(value){
            this.form.corp_ids = value;
        },

        tagChange(value){
            this.form.tag_ids = value;
        },

        authSiteChange(value){
            this.form.auth_site_ids = value;
        },

        querySearchAsync(queryString) {
            let params = {
                keyword: queryString,
            };
            CommonService.getCustomersByEs(params).then(res => {
                this.kehu_names = res.data
            });
        },
        noShow(){
            this.kehu_names = []
        }
    },

};
</script>



// WEBPACK FOOTER //
// src/views/customer-std/form.vue